import { DatePicker, TimePicker } from "antd";
import React from "react";
import styles from "../styles.module.scss";

export default function CustomTimePicker({
  title,
  required = false,
  placeholder = "-",
  value,
  onChange,
  disabled = false,
  showHour = true,
  showMinute = true,
  showSecond = true,
  style,
}) {
  return (
    <div className="d-flex flex-column gap-1">
      {title && (
        <div className={styles.title}>
          {required && <span>*</span>}
          {title}
        </div>
      )}

      <TimePicker
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        showHour={showHour}
        showMinute={showMinute}
        showSecond={showSecond}
        style={{
          minHeight: 40,
          ...style,
          // width: "100%"
        }}
      />
    </div>
  );
}
